import { Injectable } from '@angular/core';
import { Role } from "../models/role";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RoleService {

  constructor( private http:HttpClient ) { }

  getRoles() : Promise<Role[]> {
    return this.http.get<Role[]>('/api/auth/role')
      .toPromise();
  }

  postRole(role:Role) : Promise<Role> {
    return this.http.post<Role>('/api/auth/role', role).toPromise();
  }

  putRole(role:Role) : Promise<Role> {
    return this.http.post<Role>('/api/auth/role/' + role.id + '/edit', role).toPromise();
  }

}
